import i18n from "i18n";
import StringUtils from "util/StringUtils";
const VIEW_TYPE_LABELS = {
  SEARCH: "common_views.view_type.search",
  DASHBOARD: "common_views.view_type.dashboard"
};
const ViewTypeLabel = ({ type, capitalize = false }) => {
  if (!type) {
    return "";
  }
  const typeLabel = VIEW_TYPE_LABELS[type] ? i18n.t(VIEW_TYPE_LABELS[type], { ns: "search" }) : type.toLowerCase();
  return capitalize ? StringUtils.capitalizeFirstLetter(typeLabel) : typeLabel;
};
export default ViewTypeLabel;
